import React from 'react';
import { Box, Text } from '@bechtel/gds';
export interface ImportItemProps {
  label: string;
  value: string;
}

const ImportItem: React.FC<ImportItemProps> = ({ label, value }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} pb={{ sm: '500' }}>
      <Box flexDirection={{ sm: 'column' }} style={{ width: '30%' }}>
        <Box
          justifyContent={{ sm: 'space-between' }}
          pb={{ sm: '500' }}
          css={`
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
          `}
        >
          <Text weight="600" size="300" family="graphik">
            {label}
          </Text>

          <Text color="grey.1000" size="300" family="graphik">
            {value}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ImportItem;
